module.exports = __webpack_public_path__ + "static/media/Heidelberg.aa8dadc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Heidelberg.png
// module id = 77
// module chunks = 0